import { classnames } from '@app/utils/index.js';
import type { CheckoutFormSchema } from '@features/purchasing/checkout/schema';
import Image from '@store/components/Image';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { IPaymentMethod, IShippingMethod } from '../types';

type IProps = {
  isAllowed: boolean;
  selectedMethodId?: string;
} & (IShippingMethod | IPaymentMethod);

export default function Method({
  isAllowed,
  selectedMethodId,
  id,
  price,
  name,
  imageUrl,
  isFree,
  ...props
}: IProps) {
  const { t } = useTranslation();
  const { register, setValue } = useFormContext<CheckoutFormSchema>();
  const isShipping = 'citizenPayments' in props || 'companyPayments' in props;

  if (!isAllowed) {
    return <></>;
  }

  return (
    <div className="form-field">
      <label
        className={classnames(
          'flex items-center gap-x-2 px-4 py-2 border rounded-md laptop:text-base',
          {
            'cursor-pointer': isAllowed,
            'shadow-md': id === selectedMethodId,
            'shadow-primary': id === selectedMethodId,
            'bg-gray-100': !isAllowed,
            'hover:shadow-md': isAllowed,
            'hover:shadow-primary': isAllowed && id === selectedMethodId,
          }
        )}>
        <input
          {...register(isShipping ? 'shippingMethodId' : 'paymentMethodId')}
          type="checkbox"
          className="hidden"
          disabled={!isAllowed}
          onChange={() => {
            setValue(isShipping ? 'shippingMethodId' : 'paymentMethodId', id);
            if (isShipping) {
              setValue('paymentMethodId', '');
            }
          }}
        />

        <div className="flex flex-1 items-center gap-x-4">
          <span className="icon h-[32px] w-[32px] inline-flex items-center justify-center">
            {imageUrl && (
              <Image
                src={imageUrl}
                alt={name}
                className="max-w-full max-h-full object-scale-down"
                width={32}
                height={32}
              />
            )}
          </span>
          <span className="flex-1">{name}</span>
          <div className="flex flex-col mr-auto">
            {isFree && (
              <>
                <span className="text-free">{t('Free')}</span>
                {/*<span className="text-xs line-through">{price.formatted}</span>*/}
              </>
            )}
            {!isFree && <span className="">+{price.formatted}</span>}
          </div>
        </div>
      </label>
    </div>
  );
}
